import "./style.scss";
import Logo from "@/src/assets/Header/header-logo.png";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { Study } from "@/src/svg/Study";
import NavigationArrowSvg from "@/src/svg/NavigationArrowSvg";
import { headerCurrentPage } from "@/src/constants/header";
import { useEffect, useRef, useState } from "react";
import { Phone } from "@/src/svg/Phone";
import { Mail } from "@/src/svg/Mail";
import { Tiktok } from "@/src/svg/Tiktok";
import { Facebook } from "@/src/svg/Facebook";
import InstagramGraySvg from "@/src/svg/InstagramGraySvg";

const HeaderMob = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const currentPage =
    headerCurrentPage.find((page) => matchPath({ path: page.path, end: true }, location.pathname)) ||
    headerCurrentPage.find((page) => matchPath({ path: page.path, end: false }, location.pathname));

  const blockRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(false);

  const marqueeContainerRef = useRef<HTMLDivElement>(null);
  const marqueeContentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const elementContainer = marqueeContainerRef.current;
    const elementContent = marqueeContentRef.current;

    if (!elementContainer) return;
    if (!elementContent) return;
    setIsOverflowing(false);
    const timer = setTimeout(() => {
      if (elementContent.scrollWidth > elementContainer.clientWidth) {
        setIsOverflowing(true);
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [currentPage?.name]);

  useEffect(() => {
    const onScroll = () => {
      if (!blockRef.current) return;
      setIsFixed(window.scrollY > blockRef.current.offsetTop);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section ref={blockRef} className={`header-mob ${isHomePage ? "" : "single"} ${isFixed ? "is-scrolled" : ""}`}>
      {isHomePage ? (
        <>
          <div className="header-mob-top">
            <div className="container">
              <Link to={"/"} className="header-mob-number">
                <Phone />
                <p>+998 90 006 44 43 | +998 95 794 44 42</p>
              </Link>
              <a href="mailto:info@msmbmalta.com" className="header-mob-mail">
                <Mail />
                <p>info@msmbmalta.com</p>
              </a>
            </div>
          </div>
          <div className="header-mob-bottom">
            <div className="container">
              <Link className="header-mob-logo" to={"/"}>
                <img src={Logo} alt="Logo" />
              </Link>
              <div className="header-mob-links">
                <Link to={"/"}>
                  <Phone />
                </Link>
                <Link to={"/"}>
                  <Mail />
                </Link>
                <Link to={"/"}>
                  <Tiktok />
                </Link>
                <Link to={"/"}>
                  <InstagramGraySvg />
                </Link>
                <Link to={"/"}>
                  <Facebook />
                </Link>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="header-mob-top">
            <div className="container">
              <Link to={"/"} className="header-mob-number">
                <Phone />
                <p>+998 90 006 44 43 | +998 95 794 44 42</p>
              </Link>
              <a href="mailto:info@msmbmalta.com" className="header-mob-mail">
                <Mail />
                <p>info@msmbmalta.com</p>
              </a>
            </div>
          </div>
          <div className="header-mob-bottom">
            <div className="container">
              <div className="header-mob-back" onClick={() => navigate(-1)}>
                <NavigationArrowSvg />
              </div>
              <div className="header-mob-title marquee-container" ref={marqueeContainerRef}>
                <div className={`marquee-content ${isOverflowing ? "animate" : ""}`} ref={marqueeContentRef}>
                  <p>{currentPage?.name}</p>
                </div>
              </div>
              <div className="header-mob-link">
                {/* <Link to={"/"}>
                  <Study />
                </Link> */}
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default HeaderMob;
